import React from 'react';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface StyledButtonProps extends ButtonProps {
  font?: string;
}

const MuiButton = styled(Button)<StyledButtonProps>(({ font, theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.gray.main,
  display: 'block',
  textTransform: 'none',
  padding: '12px',
  font: font ? font : 'normal normal 600 20px/19px Open Sans;',
  '&:hover': {
    backgroundColor: theme.palette.solidBlue.lightHover,
    color: theme.palette.solidBlue.main,
  },
  '&:active': {
    backgroundColor: theme.palette.solidBlue.lightActive,
    color: theme.palette.solidBlue.main,
  },
}));

const NavButton = (props: any) => <MuiButton {...props} />;

export default NavButton;
